import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { ReactNode } from "react";

type Props = {
  text: string;
  children: ReactNode;
  placement?: "bottom" | "left" | "right" | "top";
  asChild?: boolean;
};

const TooltipHover = ({
  text,
  children,
  asChild,
  placement = "right"
}: Props) => {
  return (
    <TooltipProvider delayDuration={400}>
      <Tooltip>
        <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
        <TooltipContent side={placement} sideOffset={8}>
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TooltipHover;
